import { render, staticRenderFns } from "./ExtendTestSubscriptionComponent.vue?vue&type=template&id=baaee040&"
import script from "./ExtendTestSubscriptionComponent.vue?vue&type=script&lang=js&"
export * from "./ExtendTestSubscriptionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports